<template>
    <div>
        Welcome
    </div>
</template>

<script setup>
 
</script>